import { FC, ReactNode } from 'react';
import * as S from './styles';

export type MarketingMessageCardProps = {
  title: string;
  description: string;
  children: ReactNode;
} & S.TitleProps;

const MarketingMessageCard: FC<MarketingMessageCardProps> = ({
  title,
  description,
  $type,
  children,
}) => (
  <S.Card>
    {children}
    <S.Title $type={$type}>{title}</S.Title>
    <S.Description>{description}</S.Description>
  </S.Card>
);

export default MarketingMessageCard;
